export default __webpack_public_path__ + "static/media/machine.3a959718.png";